// extracted by mini-css-extract-plugin
module.exports = {"box":"DialogEnter_box_hmzT5","content":"DialogEnter_content_3xv9L"};